import React, { useRef, useEffect } from 'react';
import aboutLeft from '../img/png/about_background_left.png';
import aboutRight from '../img/png/about_background_right.png';
//gsap happens
import { TweenMax, gsap, Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function About() {
  let aboutRef = useRef([]);

  useEffect(() => {
    TweenMax.staggerFrom(
      aboutRef.current,
      0.8,
      {
        y: 15,
        ease: Power3.easeOut,
        opacity: 0,
      },
      0.3
    );
  }, []);
  return (
    <>
      <section
        id='about'
        className='about d-flex-col align-items-center justify-content-center text-center'
      >
        <div className='about_container d-flex-col align-items-center justify-content-center'>
          <p
            ref={(element) => {
              aboutRef.current[1] = element;
            }}
            className='text-primary text-center'
          >
            ABOUT US
          </p>
          <h2
            ref={(element) => {
              aboutRef.current[2] = element;
            }}
            className='text-title'
          >
            The world’s largest digital behaviour aggregator
          </h2>
          <div
            ref={(element) => {
              aboutRef.current[3] = element;
            }}
            className='about_container_paragraph text-center d-flex-col gap-1'
          >
            <p className='text-gray'>
              As a pure artificial intelligence company, we have turned the
              process of identifying, targeting, engaging, <br /> and converting
              consumers into a fully automated science.
            </p>
            <p className='text-gray'>
              We have developed an AI solution that solves some of the most
              difficult internet challenges by delivering <br />
              cookie-free, precise, Ad-targeting at scale.
            </p>
            <p className='text-gray'>
              Our technology identifies your most valuable groups of customers
              and their behaviours, not individuals, <br /> respecting privacy,
              delivering relevancy.
            </p>
            <p className='text-gray'>
              Our AI matches online behaviours with brands and publishers, and
              by integrating the Ad-ecosystem, <br /> we control delivery across
              the entire process.
            </p>
          </div>
        </div>
        <div className='about_background d-flex-row justify-content-between'>
          <div className='about_background_left d-flex-row align-items-center'>
            <img src={aboutLeft} alt='background' />
          </div>
          <img src={aboutRight} alt='background' />
        </div>
      </section>
    </>
  );
}

export default About;
